const $ = (selector) => document.querySelector(selector);
const $All = (selector) => document.querySelectorAll(selector);

document.addEventListener("DOMContentLoaded", function () {
  const elements = {
    header: $("#header"),
    menu_desk: $(".departments_desk"),
    menu_mob: $("#menu-mobile"),
    link_menu_desk: $All(".link_menu_header"),
    submenu_desk: $All(".header_nav_submenu"),
    toggle_mob_btn: $(".toggle-btn-menu"),
    mob_menu: $("#menu-mobile"),
    close_menu_mob: $("#close-menu-mobile"),
    overlay: $(".overlay-bg"),
    search_btn: $(".open-search-area-btn"),
    close_search_btn: $(".close-search-area"),
    search_area: $(".search_area"),
    submenus_mob: $All(".submenu-mob"),
  };

  elements.link_menu_desk.forEach((el) => {
    el.addEventListener("click", function (ev) {
      const submenu = ev.currentTarget.nextElementSibling;

      if (submenu) {
        ev.preventDefault();
        if (submenu.classList.contains("active")) {
          submenu.classList.remove("active");
        } else {
          elements.submenu_desk.forEach((otherSubmenu) => {
            if (otherSubmenu !== submenu) {
              otherSubmenu.classList.remove("active");
            }
          });
          submenu.classList.add("active");
        }
      }
    });
  });

  elements.submenu_desk.forEach((el) => {
    el.addEventListener("mouseleave", function () {
      el.classList.remove("active");
    });
  });

  elements.toggle_mob_btn.addEventListener("click", function () {
    handleMenuToggle(elements.mob_menu, elements.overlay, true);
  });
  [elements.close_menu_mob, elements.overlay].forEach(function (el) {
    el.addEventListener("click", function () {
      handleMenuToggle(elements.mob_menu, elements.overlay, false);
    });
  });

  elements.search_btn.addEventListener("click", function () {
    elements.search_area.classList.add("active");
  });
  elements.close_search_btn.addEventListener("click", function () {
    elements.search_area.classList.remove("active");
  });

  elements.submenus_mob.forEach((el) => {
    el.addEventListener("click", function () {
      const isActive = el.classList.contains("active");
  
      removeActiveElementsMob();
  
      if (!isActive) {
        el.classList.add("active");
      }
    });
  });
  
  function removeActiveElementsMob() {
    elements.submenus_mob.forEach((el) => el.classList.remove("active"));
  }

  // FUNCTIONS
  initializeSwiperTopBar();
});

function handleMenuToggle(menu, overlay, active) {
  if (active) {
    menu.classList.add("active");
    overlay.classList.add("active");
  } else {
    menu.classList.remove("active");
    overlay.classList.remove("active");
  }
}

function initializeSwiperTopBar() {
  new Swiper(".swiper-top-bar", {
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
  });
}

async function getSearchResultItems(value) {
  try {
    const request = await fetch(
      window.Shopify.routes.root +
        `search/suggest.json?q=${value}&resources[limit]=5&resources[type]=product&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,variants.sku`
    );

    const response = await request.json();

    const container = $(".wrapper-search-result");

    $All(".wrapper-search-result li").forEach((element) => element.remove());

    response?.resources?.results?.products.forEach(({ title, url, image }) => {
      const resultItem = document.createElement("li");
      resultItem.innerHTML = `
        <a href="${url}" title="${title}" class="flex items-center gap-3">
          <div class="result-search-image" style="width:80px;height:80px; min-width:80px">
            <img style="object-fit: contain;" class="w-full h-full" src="${image}" alt="${title}"/>                        
          </div>
          <div class="result-search-right">
            <h3>${title}</h3>                                                    
          </div>
        </a>
      `;
      container.appendChild(resultItem);
    });
    $(".search-result").classList.add("active");
  } catch (error) {
    console.error(error);
  }
}

const closeSearchResult = () => {
  $(".search-result").classList.remove("active");
};
